// extracted by mini-css-extract-plugin
module.exports = {"container":"drBmY","width_default":"vzE7d","width_narrow":"zbNJG"};